import { DataObject, DateTimeStamps } from "./common"
import { LocationId, Location } from "./location"
import { Level } from "./level"
import { Group, GroupDataObject, GroupId } from "./group"

export type UserId = number
export type UserEmail = string
export type UserTitle = string
export type UserFirstName = string
export type UserMiddleName = string
export type UserLastName = string
export type UserNickName = string
export type UserBirthDate = string
export type AvatarURL = string

export interface User {
  id: UserId;
  email?: UserEmail;
  title?: UserTitle;
  firstName?: UserFirstName;
  middleName?: UserMiddleName;
  lastName?: UserLastName;
  nickName?: UserNickName;
  birthDate?: UserBirthDate;
  userRoles?: Array<UserRole>;
  userLevels?: Array<UserLevel>;
  userLocations?: Array<UserLocation>;
  createdAt?: DateTimeStamps;
  updatedAt?: DateTimeStamps;
  avatarUrl?: AvatarURL;
}

export interface UserDataObject {
  id: UserId;
  birth_date: UserBirthDate
  email: UserEmail
  firstname: UserFirstName
  lastname: UserLastName
  user_roles?: Array<UserRole>
  user_levels?: Array<UserLevel>
  user_locations?: Array<UserLocation>
  location_id?: LocationId
  nickname: UserNickName
  title: UserTitle
}

export interface UserRole {
  user?: User
  role?: Role
  createdAt?: DateTimeStamps
}

export interface UserLevel {
  user?: User
  level?: Level
  createdAt?: DateTimeStamps
}

export interface UserLocation {
  user?: User
  location?: Location
  createdAt?: DateTimeStamps
}

export type RoleId = number

export enum DefaultRole {
  ADMINISTRATOR = 'ADMINISTRATOR',
  AUDITOR = 'AUDITOR',
  TEACHER = 'TEACHER',
  STUDENT = 'STUDENT',
  PARENT = 'PARENT',
  DEVELOPER = 'DEVELOPER'
}

export enum StreamRoleEnum {
  HOST = 'HOST',
  ATTENDEE = 'ATTENDEE',
  AUDITOR = 'AUDITOR'
}

export enum PermissionRole {
  ADMINISTRATOR = 'ADMINISTRATOR',
  PARTICIPANT = 'PARTICIPANT',
  AUDITOR = 'AUDITOR',
  EDITOR = 'EDITOR'
}

export type RoleName = DefaultRole | StreamRoleEnum | PermissionRole

export interface Role {
  id: RoleId
  name: RoleName
  createdAt?: DateTimeStamps
  updatedAt?: DateTimeStamps
}

export interface UserGroup {
  groupId?: GroupId
  group?: Group
  user?: User
  role?: Role
  roleId?: RoleId
  group_id?: GroupId
  user_id?: UserId
  role_id?: RoleId
}

export interface UserGroupDataObject {
  group_id?: GroupId
  group?: DataObject<GroupDataObject>
  role_id?: RoleId
  user_id?: UserId
}
